import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './StickyAlertBar';
import { HeroSection } from './HeroSection';
import { SalesLetterSection } from './SalesLetterSection';
import { WhatYouGetSection } from './WhatYouGetSection';
import { BonusSection } from './BonusSection';
import { PaymentMethodsSection } from './PaymentMethodsSection';
import { PricingSection } from './PricingSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FooterSection } from './FooterSection';
export function LandingPage() {
  useEffect(() => {
    ;
    (window as any).pixelId = '69cd7a0a5053203c6834d72e';
    const pixelScript = document.createElement('script');
    pixelScript.setAttribute('async', '');
    pixelScript.setAttribute('defer', '');
    pixelScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(pixelScript);
    const utmsScript = document.createElement('script');
    utmsScript.setAttribute('async', '');
    utmsScript.setAttribute('defer', '');
    utmsScript.setAttribute('data-utmify-prevent-subids', '');
    utmsScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/utms/latest.js');
    document.head.appendChild(utmsScript);
    return () => {
      document.head.removeChild(pixelScript);
      document.head.removeChild(utmsScript);
    };
  }, []);
  return <div className="min-h-screen flex flex-col font-sans selection:bg-orange-500 selection:text-white" data-id="element-72">
      <StickyAlertBar data-id="element-73" />
      <main className="flex-grow" data-id="element-74">
        <HeroSection data-id="element-75" />
        <SalesLetterSection data-id="element-76" />
        <WhatYouGetSection data-id="element-77" />
        <BonusSection data-id="element-78" />
        <PaymentMethodsSection data-id="element-79" />
        <PricingSection data-id="element-80" />
        <TestimonialsSection data-id="element-81" />
        <FAQSection data-id="element-82" />
      </main>
      <FooterSection data-id="element-83" />
    </div>;
}